import DeleteIcon from '@mui/icons-material/Delete';
import {
    Box,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemSecondaryAction,
    ListItemText
} from "@mui/material";
import _, {isNumber} from "lodash";
import {DateTime} from "luxon";
import {useState} from "react";
import {ModalComponent} from "../../../components/Modal/ModalComponent";
import {AgeGroup} from "../../../models/ClimbingEvent";
import {ageRangeToString} from "../../../services/time/TimeService";
import {useTranslation} from "react-i18next";
import {EditAgeGroup} from "./EdditAgeGroup";

type Props = {
    handleUpdateAgeGroup: (ageGroups: AgeGroup[]) => void,
    
    ageGroups: AgeGroup[],
}
export const AddingAgeGroups: React.FC<Props> = ({ handleUpdateAgeGroup, ageGroups }) => {
    const [selectedGroup, setSelectedGroup] = useState<AgeGroup | null>(null)
    const {t} = useTranslation()
    const createNewId = (): number => {
        const id = _.maxBy(ageGroups, (g) => g.id)?.id
        return isNumber(id) ? id + 1 : 1
    }

    const getLastYear = (): number => {
        const lastYear = _.maxBy(ageGroups, (g) => g.endYear)?.endYear
        return isNumber(lastYear) ? lastYear + 1 : DateTime.now().year - 80
    }

    const handleUpdate = (group: AgeGroup) => {
        const indexToUpdate = ageGroups.findIndex(g => g.id === group.id)
        if (indexToUpdate !== -1) {
            ageGroups[indexToUpdate] = group
        } else {
            ageGroups.push(group)
        }
        setSelectedGroup(null)
        handleUpdateAgeGroup(ageGroups)
    }


    return <Box>
        <List>
            {ageGroups.map((group, index) => (
                <ListItem key={"group_" + index}>
                    <ListItemButton onClick={()=>setSelectedGroup(group)}>
                        <ListItemText primary={group.name} secondary={ageRangeToString(t("event.ageGroup.younger"),t("event.ageGroup.older"),group.startYear,group.endYear)} />
                    </ListItemButton>
                    <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="delete" onClick={() => handleUpdateAgeGroup(ageGroups.filter((_, i) => i !== index))}>
                            <DeleteIcon />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
            ))}
        </List>
        <Button onClick={(click) => {
            setSelectedGroup({ id: createNewId(), name: "", startYear: getLastYear() })
            handleUpdateAgeGroup(ageGroups)
        }}> Dodaj grupę Wiekową</Button>
        {selectedGroup && <ModalComponent open={true} onClose={() => setSelectedGroup(null)} childComp={<EditAgeGroup group={selectedGroup} handleUpdateGroup={handleUpdate} />} />
    }
       
    </Box>
}

